import UspsRouter from "./Usps.router";

export default UspsRouter;
